export default function formatRupiah(
  angka: number | string,
  opt?: { prefix?: string; suffix?: boolean }
): string {
  if (!angka) {
    return "Rp. 0";
  }

  let separator;
  var number_string = angka.toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;

  if (opt?.suffix) {
    rupiah = formatNumber(rupiah);
  }

  return opt?.prefix === undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
}

function formatNumber(angka: string): string {
  const divided = angka.split(".");
  if (divided.length === 1) {
    return divided[0];
  }

  divided[divided.length - 1] = divided[divided.length - 1].replace(
    /\d{3}/gi,
    "k"
  );
  return divided.join("");
}
